// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3RRz0","options":"AnswerScale_options__123FR","selected":"AnswerScale_selected__T32Iy"};